import {RefundData} from "./refund-data";

export class RefundDataMapper {
  public static map(data: any): RefundData {
    let refund: RefundData = new RefundData();
    refund.id = data.id;
    refund.amount = data.amount;
    refund.dateCreated = data.date_created;
    refund.reason = data.reason;
    refund.lineItems = data.line_items;
    return refund;
  }

}
